import { gql } from '@urql/vue';

const FRAGMENT_DEVICE = gql`
  fragment device on DeviceRegistration {
    id
    serialNumber
    name
    environmentId
    createdAt
    registeredByUser {
      id
      username
    }
    assignedAt
    assignedByUser {
      id
      username
    }
  }
`;

export interface DeviceUser {
  id: string;
  username: string;
}

export interface Device {
  id: number;
  serialNumber: string;
  name: string;
  environmentId: string;
  createdAt: string;
  registeredByUser?: DeviceUser | null;
  assignedAt?: string | null;
  assignedByUser?: DeviceUser | null;
}

export const DEVICES = gql`
  ${FRAGMENT_DEVICE}
  query ($envId: String, $query: String, $page: Int, $limit: Int) {
    deviceRegistrations(environmentId: $envId, query: $query, page: $page, limit: $limit) {
      ...device
    }
  }
`;

export const ASSIGN_DEVICE = gql`
  ${FRAGMENT_DEVICE}
  mutation ($input: AssignDeviceInput!) {
    assignDevice(input: $input) {
      ...device
    }
  }
`;

export const REGISTER_DEVICE = gql`
  ${FRAGMENT_DEVICE}
  mutation ($input: RegisterDeviceInput!) {
    registerDevice(input: $input) {
      ...device
    }
  }
`;

export const DELETE_DEVICE = gql`
  mutation ($registrationId: Int!) {
    deleteRegistration(registrationId: $registrationId)
  }
`;
